import { Theme } from '@material-ui/core';
import { makeStyles, StyleRules } from '@material-ui/core/styles';

const generateStyles = (theme: Theme) => {
  const styles: StyleRules = {
    td: {
      padding: theme.spacing(0, 1),
    },
    phonePlatformCell: {
      width: 100,
      margin: 'auto',
    },
  };
  return styles;
};

const useStyles: () => Record<keyof ReturnType<typeof generateStyles>, string> =
  makeStyles(generateStyles);

export default useStyles;
